module.exports = __webpack_public_path__ + "img/img13.1d7cb4f6.jpg";